import { Card, CardHeader, Chip, Grid, List, Stack } from "@mui/material";
import { PropertyListItem } from "components/property-list-item";

interface CustomProps {
  ticketDetails: any;
  isLoading: boolean;
}

const TicketDetails = (props: CustomProps) => {
  const getColorBasedOnPriority = (priority: string) => {
    switch (priority) {
      case "High": {
        return "rgb(250, 101, 101)";
      }
      case "Medium": {
        return "rgb(246, 186, 95)";
      }
      case "Low": {
        return "rgb(1, 202, 82)";
      }
    }
  };

  return (
    <Stack direction={"column"} spacing={1}>
      <Card
        sx={{
          "&.MuiCard-root": {
            p: 1,
          },
        }}
      >
        <CardHeader title="Details" color="text.primary" />
        <List>
          <PropertyListItem
            divider
            label="Status"
            value={props.ticketDetails?.status}
            isLoading={props.isLoading}
          />
          <PropertyListItem
            divider
            label="Assignee"
            children={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                mt={1}
              >
                <Grid container spacing={1}>
                  <Grid item display="flex" flexWrap="wrap" gap={1}>
                    {props.ticketDetails?.hasOwnProperty("assigneeName") ? (
                      props.ticketDetails?.assigneeName
                        ?.split(",")
                        .map((data: any) => {
                          return (
                            <Chip
                              label={data}
                              key={data}
                              size="small"
                              sx={{
                                backgroundColor: "#EBEFFF",
                                fontSize: "13px",
                              }}
                            />
                          );
                        })
                    ) : (
                      <Chip
                        label="Unassigned"
                        size="small"
                        sx={{
                          backgroundColor: "#EBEFFF",
                          fontSize: "13px",
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Stack>
            }
            isLoading={props.isLoading}
          />
          <PropertyListItem
            divider
            label="Reporter"
            value={props.ticketDetails?.assignorName}
            isLoading={props.isLoading}
          />
          <PropertyListItem
            divider
            label="Category"
            value={props.ticketDetails?.process}
            isLoading={props.isLoading}
          />
          <PropertyListItem
            label="Priority"
            children={
              <Chip
                size="small"
                sx={{
                  background: getColorBasedOnPriority(
                    props.ticketDetails?.priority
                  ),
                  color: "#FFFFFF",
                  fontSize: "13px",
                  "&:hover": {
                    background: getColorBasedOnPriority(
                      props.ticketDetails?.priority
                    ),
                    color: "#FFFFFF",
                  },
                }}
                label={props.ticketDetails?.priority}
              />
            }
            isLoading={props.isLoading}
          />
        </List>
      </Card>
    </Stack>
  );
};

export default TicketDetails;
